<template>
	<div class="train-manage-page">
		<div class="page-nav">
			<div class="nav-item" v-for="item in navList" :key="item.value"
				:class="currentPage === item.value ? 'actived' : ''" @click="itemClick(item)">
				{{ item.name }}
			</div>
		</div>
		<daily-report 
			v-if="currentPage === 'dailyReport'"
			:deviceAbnormalDict="deviceAbnormalDict" 
			:workOrderStatusDict="workOrderStatusDict" 
		></daily-report>
		<project-month-report 
			v-if="currentPage === 'projectReport'"
			:hardwareList="hardwareList"
		></project-month-report>
		<month-report 
			v-if="currentPage === 'monthReport'"
			:hardwareList="hardwareList"
		></month-report>
	</div>
</template>

<script>
import dailyReport from './components/dailyReport.vue'
import monthReport from './components/monthReport.vue'
import projectMonthReport from './components/projectMonthReport.vue'
import { getDeviceAbnormalDict, getWorkOrderStatusDict, getHardwareList } from '@/api/hardwarestatistic';
export default {
	components: { dailyReport, monthReport, projectMonthReport },
	data () {
		return {
			navList: [
				{ name: '硬件报警日报表', value: 'dailyReport' },
				{ name: '项目硬件月报', value: 'projectReport' },
				{ name: '硬件情况统计月报', value: 'monthReport' }
			],
			currentPage: "dailyReport",
			deviceAbnormalDict: [],
			workOrderStatusDict: []
		}
	},
	mounted () {
		this.getDeviceAbnormalDict();
		this.getWorkOrderStatusDict();
		this.getHardwareList();
	},
	methods: {
		// 获取设备异常原因字典
		async getDeviceAbnormalDict() {
			// 发起网络请求获取设备异常字典
			const response = await getDeviceAbnormalDict();
			if (response.data.statusCode === 200) {
				// 验证数据格式
				if (Array.isArray(response.data.data)) {
					this.deviceAbnormalDict = response.data.data;
				} else {
					console.error('Invalid data format for device abnormal dict');
				}
			}
		},
		// 获取工单状态字典
		async getWorkOrderStatusDict() {
			// 发起网络请求获取工单状态字典
			const response = await getWorkOrderStatusDict();
			if (response.data.statusCode === 200) {
				// 验证数据格式
				if (Array.isArray(response.data.data)) {
					this.workOrderStatusDict = response.data.data;
				} else {
					console.error('Invalid data format for work order status dict');
				}
			}
		},
		// 获取硬件下拉字典
		async getHardwareList() {
			// 发起网络请求获取硬件下拉字典
			const response = await getHardwareList();
			if (response.data.statusCode === 200) {
				// 验证数据格式
				if (Array.isArray(response.data.data)) {
					this.hardwareList = response.data.data;
				} else {
					console.error('Invalid dataformat for hardware list');
				}
			}
		},
		itemClick (val) {
			this.currentPage = val.value;
		}
	}
}
</script>

<style lang="scss" scoped>
.page-nav {
	display: flex;
	margin-bottom: 20px;

	.nav-item {
		padding: 10px 20px;
		font-size: 16px;
		margin-right: 10px;
		text-align: center;
		color: #fff;
		background: url(./../../../assets/img/tab.png) no-repeat center;
		background-size: 100% 100%;
		cursor: pointer;
	}

	.actived {
		background: #2f65ec;
	}
}
</style>